<script>
  import { onMount } from "svelte";
  import {
    Article,
    Table,
    Modal,
    Toast,
    Collapsible,
    Breadcrumb,
  } from "spaper";
  import { link, navigate } from "svelte-routing";
  import { strings } from "../constants/strings";
  import { isAdmin } from "../stores/stores";
  import {
    loadAdoptableInfo,
    deleteAdoptable,
    showErrorThenCallback,
  } from "../utils/utils";
  import HeaderMini from "../components/HeaderMini.svelte";
  import Footer from "../components/Footer.svelte";

  export let id;
  export let kind;

  let adoptableInfo = {
    name: "Nombre",
    age: 12,
    sex: strings.adoptableProps.sex.female,
    temper: strings.adoptableProps.temper.active,
    image: "",
    description: "Descripción...",
    likeschildren: false,
    likesotherpets: false,
    sterilized: false,
  };
  let ageText = adoptableInfo.age;
  $: ageText = getAgeText(adoptableInfo.age);

  const getAgeText = (age) => {
    if (!age || isNaN(age)) return "";
    const ageYears = parseInt(age / 12);
    const ageMonths = age % 12;
    let ageString = "";
    if (ageYears > 0) {
      ageString = ageYears == 1 ? "1 año" : `${ageYears} años`;
    }
    if (ageYears > 0 && ageMonths > 0) {
      ageString += " con ";
    }
    if (ageMonths > 0) {
      ageString += ageMonths == 1 ? "1 mes" : `${ageMonths} meses`;
    }
    return ageString;
  };

  const _getTableData = (info, position) => {
    let _tdata = {};
    if (position == "up") {
      _tdata = {
        Sexo: strings.adoptableProps.sex[info.sex],
        Color: strings.adoptableProps.color[info.color],
        Edad: ageText,
        Tamaño: strings.adoptableProps.size[info.size],
      };
      if (kind == "cat") {
        delete _tdata["Tamaño"];
      }
    } else {
      _tdata = {
        Temperamento: strings.adoptableProps.temper[info.temper],
        "Convive con niños": info.likeschildren ? "Sí" : "No",
        "Convive con mascotas": info.likesotherpets ? "Sí" : "No",
        Esterilizado: info.sterilized ? "Sí" : "No",
        Publicado: info.published ? "Sí" : "No",
      };
      if (!$isAdmin) {
        delete _tdata["Publicado"];
      }
    }
    return [_tdata];
  };

  $: breadcrumbPath = [
    {
      text: "Administrador",
      href: "/_admin",
    },
    {
      text: "Adoptables",
      href: "/adoptables",
    },
    {
      text: adoptableInfo.name,
      href: `/adoptable/${kind}/${id}`,
    },
  ];

  $: tableDataUp = _getTableData(adoptableInfo, "up");
  $: table2DataDown = _getTableData(adoptableInfo, "down");

  onMount(async () => {
    try {
      adoptableInfo = await loadAdoptableInfo(id, kind);
    } catch (error) {
      showErrorThenCallback(error, () => {
        navigate("/");
      });
    }
  });

  let activeModal = false;

  const showConfirmation = () => (activeModal = true);

  const deleteConfirmation = async () => {
    activeModal = false;
    Toast.open({
      message: "Eliminando...",
      type: "warning",
      position: "bottom",
    });
    try {
      await deleteAdoptable(id, kind);
    } catch (errorMessage) {
      console.error(errorMessage);
    } finally {
      navigate("/");
    }
  };
</script>

<svelte:head>
    {#if adoptableInfo}
    <title>{adoptableInfo.name}</title>
    <meta name="og:title" property="og:title" content="{adoptableInfo.name}" />
    <meta name="og:description" property="og:description" content="{adoptableInfo.description}" />
    <meta name="og:image" property="og:image" content="{adoptableInfo.image}" />
    {/if}
</svelte:head>

<HeaderMini />
{#if $isAdmin}
  <Breadcrumb items={breadcrumbPath} />
{/if}
<div class="main-content">
  <Article title={adoptableInfo.name}>
    <p slot="meta">
      <Collapsible label="Ver detalles...">
        <Table data={tableDataUp} />
        <Table data={table2DataDown} />
      </Collapsible>
    </p>
    <p style="white-space: pre-wrap">
      <img
        src={`${adoptableInfo.image}?x=${new Date()}`}
        alt="{adoptableInfo.name} image"
        class="float-left"
      />
      {adoptableInfo.description}
    </p>
    <p slot="footer">
      {#if !$isAdmin}
        <a href={`/adopt/${kind}/${id}`} use:link class="paper-btn btn-danger">
          {#if adoptableInfo.sex == "female"}
            ¡Quiero adoptarla!
          {:else}
            ¡Quiero adoptarlo!
          {/if}
        </a>
      {:else}
        <a
          href={`/_editadoptable/${kind}/${id}`}
          use:link
          class="paper-btn btn-success"
        >
          Editar
        </a>
        <button class="btn-danger" on:click={showConfirmation}>Eliminar</button>
        <Modal title="Eliminar" closeBtnText="No" bind:active={activeModal}>
          ¿Relamente desea eliminar a {adoptableInfo.name}?
          <br />
          <button class="btn-danger" on:click={deleteConfirmation}
            >Sí, eliminar</button
          >
        </Modal>
      {/if}
    </p>
  </Article>
</div>
<Footer />

<style>
  img {
    display: block;
    margin: auto;
    width: 300px;
  }

  a,
  a:visited {
    background-image: none !important;
    text-decoration: none;
  }

  .main-content {
    margin-bottom: 2vh;
  }
</style>
